/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UnansweredCommentsTabCommentContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_viewer" | "CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "UnansweredCommentsTabCommentContainer_viewer";
};
export type UnansweredCommentsTabCommentContainer_viewer$data = UnansweredCommentsTabCommentContainer_viewer;
export type UnansweredCommentsTabCommentContainer_viewer$key = {
    readonly " $data"?: UnansweredCommentsTabCommentContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabCommentContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnansweredCommentsTabCommentContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'dcfef4eaeff658eaca39bf9bb0c599aa';
export default node;
